<template>
  <div
    class="verify-upload"
    :class="{
      'cursor-pointer': !disabled,
    }"
    @click="() => (disabled ? '' : open?.())"
  >
    <a-spin :spinning="upLoading" class="!h-full">
      <div v-if="modelValue" class="cover-wrapper">
        <div class="action-option flex-y-center gap-[15px] p-[10px]">
          <a
            v-if="isPdf"
            class="text-white"
            :href="modelValue"
            target="_blank"
            @click.stop
          >
            <iconpark-icon name="eye" :title="$t('yu-lan')" size="26">
            </iconpark-icon>
          </a>
          <a v-else class="text-white" @click.stop="handlePreview">
            <iconpark-icon
              name="eye"
              :title="$t('yu-lan')"
              size="26"
            ></iconpark-icon>
          </a>
          <a v-if="!disabled" class="text-white" @click.stop="handleDelete">
            <iconpark-icon
              :title="$t('shan-chu-wen-jian')"
              name="delete-simple"
              class="text-[20px]"
            ></iconpark-icon>
          </a>
        </div>
      </div>
      <div v-if="!modelValue" class="text-center px-[5px]">
        <iconpark-icon
          name="plus-circle-fill"
          size="32"
          class="text-primary"
        ></iconpark-icon>
        <div v-if="text" class="font-medium text-center mt-[5px]">
          {{ text }}
          <div v-if="desc" class="text-12 font-normal text-font-70">
            {{ desc }}
          </div>
        </div>
      </div>
      <img
        v-else
        :src="imgSrc"
        loading="lazy"
        class="w-full max-h-full"
        :class="{
          '!w-3/5': isPdf,
        }"
      />
    </a-spin>
  </div>
</template>
<script lang="ts" setup>
import { message } from 'ant-design-vue'
import { MB_ATOM, transSize, useUpload } from '~/hooks/useUpload'
import { useImgView } from '~/hooks/useModal/modals/view'

const props = defineProps<{
  text?: string
  desc?: string
  accept: any[]
  modelValue: string
  max?: number
  disabled?: boolean
}>()

const emits = defineEmits(['update:modelValue'])
const isPdf = computed(() => {
  if (!props.modelValue) {
    return false
  }

  const suffix =
    props.modelValue.split('?')?.[0]?.split('.')?.pop()?.toLowerCase() || ''

  return ['pdf'].includes(suffix)
})

const imgSrc = computed(() =>
  isPdf.value ? getFeUrl('/youyan-platform/svg/icon-pdf.svg') : props.modelValue
)
const { $t } = useNuxtApp()

const {
  open,
  loading: upLoading,
  simpleUpload,
} = useUpload({
  noModal: true,
  accept: '.' + props.accept.join(',.'),
  hasMessage: false,
  beforeUpload: (file) => {
    const suffix = (file.name.split('.').pop() || '').toLowerCase()
    if (!props.accept.includes(suffix)) {
      message.error(
        $t('qing-shang-chuan-acceptjoin-ge-shi-wen-jian', [
          props.accept.join('、'),
        ])
      )
      return false
    }
    if (props.max) {
      const size = MB_ATOM * props.max
      if (file.size > size) {
        message.error(
          $t(
            'wen-jian-da-xiao-bu-neng-chao-guo-transsizesizemb-dang-qian-transsizefilesizemb',
            [transSize(size), transSize(file.size)]
          )
        )
        return false
      }
    }
    simpleUpload?.(file)
    return false
  },
  onSuccess: (_, res) => {
    emits('update:modelValue', res.file_url)
  },
})

const handleDelete = () => {
  emits('update:modelValue', undefined)
}

const handlePreview = () => {
  useImgView(transformImage(props.modelValue))
}
</script>
<style lang="scss" scoped>
.verify-upload {
  @apply rounded-[8px] bg-back-4 relative overflow-hidden;
  border: 1px dashed var(--purple-3);
  :deep(.ant-spin-container) {
    @apply flex flex-col justify-center items-center;
  }
  :deep(.ant-spin-nested-loading) {
    height: 100%;
  }
  :deep(.ant-spin-container) {
    height: 100%;
  }
  &:hover {
    border-color: var(--purple-4);
    .cover-wrapper {
      @apply opacity-100;
    }
  }
  .cover-wrapper {
    @apply absolute text-white w-full h-full flex justify-center items-center opacity-0;
    background-color: var(--text-1-50);
  }
}
</style>
